import {
  type OFFER_CARGO_PROCESS_RECEPTION_STATUS,
  OfferCargoProcessReceptionStatusLabels,
  isOfferCargoProcessReceptionStatus,
} from "@/features/offer-cargo-process-status/badge-status";
import { BaseSelect } from "@/shared/ui/base-select";
import { MenuItem } from "@mui/material";

type Props = {
  value: OFFER_CARGO_PROCESS_RECEPTION_STATUS | undefined;
  onChange: (value: OFFER_CARGO_PROCESS_RECEPTION_STATUS | undefined) => void;
};

export const SelectReceptionStatus = ({ value, onChange }: Props) => {
  return (
    <BaseSelect
      value={value}
      size="small"
      type="string"
      noSelectedOptionText="(選択解除)"
      onChange={(v) => {
        onChange(isOfferCargoProcessReceptionStatus(v) ? v : undefined);
      }}
    >
      {OfferCargoProcessReceptionStatusLabels.map((value) => (
        <MenuItem key={value.status} value={value.status}>
          {value.label}
        </MenuItem>
      ))}
    </BaseSelect>
  );
};
